import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo/dark.png'


const _hoisted_1 = { class: "leftpart" }
const _hoisted_2 = { class: "leftpart_inner" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = { class: "copyright" }
const _hoisted_6 = { class: "rightpart" }
const _hoisted_7 = { class: "rightpart_in" }
const _hoisted_8 = { class: "theme_a_section" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "tabcontent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_MenuItem, {
            text: "Home",
            link: "/",
            icon: _ctx.home
          }, null, 8, ["icon"]),
          _createVNode(_component_MenuItem, {
            text: "Experiences",
            link: "experiences",
            icon: _ctx.avatar
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(new Date().getFullYear()) + " Ahmed Allam.", 1),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "relative" }, [
              _createElementVNode("span", { style: {"padding-right":"26px"} }, " Crafted with "),
              _createElementVNode("span", { class: "heart" }),
              _createElementVNode("span", null, " by me ")
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}